export default __webpack_public_path__ + "static/media/Blazing Strike.53664288.png";